import {
  FETCH_LOGIN,
  FETCH_LOGIN_FAILED,
  FETCH_LOGIN_SUCCESS
} from '../../types';

const initialState = {
  user: {},
  isAuth: false,
  isLoading: false,
  errors: {},
  error: false
}


const fetchLoginEmailReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOGIN:
      return {
        ...state,
        isLoading: true,
          isAuth: false,
          user: action.payload
      }
      case FETCH_LOGIN_SUCCESS:
        return {
          ...state,
          isLoading: false,
            isAuth: true,
            user: action.payload
        }
        case FETCH_LOGIN_FAILED:
          return {
            ...state,
            isLoading: false,
              isAuth: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchLoginEmailReducer;
